import { ButtonV2, Flex, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const transferDialogOverrides = {
  Content: {
    props: {
      width: pxToRem(480),
      maxWidth: '100%',
    },
  },
};

export const TransferDialogBody = styled(Flex)`
  flex-direction: column;
  background: white;
  min-height: 100%;
`;

export const PromoCard = styled(Flex)`
  background: linear-gradient(115deg, #5a1d65 52.24%, #58004c 94.37%);
  border-radius: ${({ theme }) => theme.radii?.[4] ?? pxToRem(12)};
  overflow: hidden;
`;

export const PromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(25)};
  font-weight: 600;
  color: white;
`;

export const PromoSubhead = styled(TextV2)`
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(25)};
  color: white;
  text-align: left;
`;

export const PromoBullet = styled(TextV2)`
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(20)};
  color: white;
  text-align: left;
`;

export const PromoOpenButton = styled(ButtonV2)`
  &:hover {
    background-color: #f0f0f0;
  }
`;
